// Libs
import classNames from 'classnames/bind';
import { Tooltip, Typography } from '@mui/material';
import { useEffect, useRef, useState } from 'react';
// Components, Layouts, Pages
// Others
// Styles, images, icons
import styles from './TextTooltip.module.scss';

type Props = {
  text?: string;
  className: string;
};

const cx = classNames.bind(styles);

const TextTooltip = (props: Props) => {
  //#region Destructuring Props
  const { text, className } = props;
  //#endregion Destructuring Props

  //#region Declare Hook
  const ref = useRef<HTMLElement>(null);
  //#endregion Declare Hook

  //#region Selector
  //#endregion Selector

  //#region Declare State
  const [isOverflowed, setIsOverflowed] = useState(false);
  //#endregion Declare State

  //#region Declare Memo
  //#endregion Declare Memo

  //#region Implement Hook
  useEffect(() => {
    const element = ref.current;
    if (!element) return;

    const checkOverflow = () => {
      setIsOverflowed(element.scrollWidth > element.offsetWidth);
    };

    checkOverflow();

    const observer = new ResizeObserver(checkOverflow);
    observer.observe(element);

    return () => observer.unobserve(element);
  }, [text]);
  //#endregion Implement Hook

  //#region Handle Function
  //#endregion Handle Function

  return (
    <Tooltip arrow placement='top-start' title={text} disableHoverListener={!isOverflowed}>
      <Typography ref={ref} className={`${cx('text')} ${className}`}>
        {text}
      </Typography>
    </Tooltip>
  );
};

export default TextTooltip;
